import "./codePalette.css";
import { resolveCodeLanguage } from "./HighlightedCode";

type Shiki = typeof import("./ShikiHighlighter");

// Static examples come pre-highlighted from the build (see HighlightedCode.ts). Anything else, such
// as live JSON, goes through Shiki (ShikiHighlighter.ts). Shiki and each grammar load the first time
// code needs them, on the server as in the browser. The server finishes rendering before it sends a
// page (CompleteDocumentHandler), so server-rendered code is always highlighted. In the browser, code
// keeps its server-rendered markup until its grammar arrives; code first rendered there shows its
// fallback meanwhile.
let shiki: Shiki | undefined;

let shikiLoad: Promise<Shiki> | undefined;

const languageLoads = new Map<string, Promise<void>>();

/** Loads Shiki and, given a language, its grammar; ahead of time when code will need it. */
export const loadShiki = (language?: string): Promise<void> => {
  shikiLoad ??= import("./ShikiHighlighter").then((module) => {
    shiki = module;
    return module;
  });
  const lang = language === undefined ? "text" : resolveCodeLanguage(language);
  let load = languageLoads.get(lang);
  if (!load) {
    load = shikiLoad.then((module) => module.loadCodeLanguage(lang));
    languageLoads.set(lang, load);
  }
  return load;
};

/** Shiki once `loadShiki` has loaded it. */
export const getLoadedShiki = () => shiki;
